/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ offset: NonNullable<unknown> }} Body_Assessment_Anchor_OffsetInputs */

const en_us2_body_assessment_anchor_offset = /** @type {(inputs: Body_Assessment_Anchor_OffsetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Adjustment applied to your estimates: ${i?.offset} pp`)
};

const pt_br2_body_assessment_anchor_offset = /** @type {(inputs: Body_Assessment_Anchor_OffsetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ajuste aplicado às suas estimativas: ${i?.offset} p.p.`)
};

const es_419_body_assessment_anchor_offset = /** @type {(inputs: Body_Assessment_Anchor_OffsetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ajuste aplicado a tus estimaciones: ${i?.offset} p. p.`)
};

const pt_pt2_body_assessment_anchor_offset = /** @type {(inputs: Body_Assessment_Anchor_OffsetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ajuste aplicado às tuas estimativas: ${i?.offset} p.p.`)
};

const fr_fr2_body_assessment_anchor_offset = /** @type {(inputs: Body_Assessment_Anchor_OffsetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ajustement appliqué à tes estimations : ${i?.offset} pts`)
};

const de_de2_body_assessment_anchor_offset = /** @type {(inputs: Body_Assessment_Anchor_OffsetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Korrektur deiner Schätzungen: ${i?.offset} Pp.`)
};

const it_it2_body_assessment_anchor_offset = /** @type {(inputs: Body_Assessment_Anchor_OffsetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Correzione applicata alle tue stime: ${i?.offset} p.p.`)
};

/**
* | output |
* | --- |
* | "Adjustment applied to your estimates: {offset} pp" |
*
* @param {Body_Assessment_Anchor_OffsetInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_anchor_offset = /** @type {((inputs: Body_Assessment_Anchor_OffsetInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Anchor_OffsetInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_anchor_offset(inputs)
	if (locale === "es-419") return es_419_body_assessment_anchor_offset(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_anchor_offset(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_anchor_offset(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_anchor_offset(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_anchor_offset(inputs)
	return en_us2_body_assessment_anchor_offset(inputs)
});
export { body_assessment_anchor_offset as "body-assessment.anchor_offset" }